export enum PosterSectionType {
  MY_DESIGNS = '1',
  SHARED_WITH_ME = '3',
}